<template>
  <div style="height: 100%; width: 100%">
    <div style="width: 100%; height: 100%; ">
      <el-amap vid="amapDemo" :zoom="zoom" view-mode="3D" :pitch="47" :show-building-block="true" :center="center"
        :events="mapEvents" :markers="markers" style="width: 100%; height: 100%; border-radius: 5px">



        <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :visible="marker.visible"
          :draggable="marker.draggable" @init="markerInit" @click="clickMarker">
          <div style="padding: 5px 10px;white-space: nowrap;background: #1a83ff;color: #fff;">
            {{ marker.name }}总交易额: 
           <span style="color: red;"> {{ marker.amount }}万元</span>
          </div>
        </el-amap-marker>

      </el-amap>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      zoom: 9.1,
      unitCode: localStorage.getItem("unitCode"),
      showDatas:[],
      unitCodes:[],
      tradeData:{},
      markers:[],
      center:[121.422318,31.303038],
      styles: {
        'fill': '#00baff',
        'province-stroke': 'cornflowerblue',
      },
      mapEvents: {
        init(map) {
          map.setMapStyle('amap://styles/blue');
          // const marker = new AMap.Marker({
          //   position: [114.091058, 32.148624]
          // });
          // map.add(marker);
          this.map = map;
        },

      },
    

    };
  },
  components: {
    // Chart,
  },
  created() {
    
    if(this.unitCode=="411500000000"){
        this.center=[114.09748 , 32.15301];
      }
      if(this.unitCode=="410825000000"){
        this.center=[113.085992, 34.946372];
      }
      if(this.unitCode=="410225000000"){
        this.center=[114.821348, 34.822211];
      }

    this.getData();
    

  },
  

  methods: {
    async getData(){
    if(this.unitCode.indexOf("00000000")!=-1){
      this.getCountys();
    }
    else{
      this.getTowns();
    }
    this.showData();

  },
    async getCountys() {
      this.selectUnitCode = this.unitCode;
      const action = "/web/unitCode/getXians/" + this.unitCode;
      const {
        data: res
      } = await this.$http.get(action);
      this.unitCodes = res.data;
    },
    async getTowns() {
      const action = "/web/unitCode/getXiangs/" +  this.unitCode;;
      const {
        data: res
      } = await this.$http.get(action);
      this.unitCodes = res.data;
    },
    showData() {
        this.$http.get("/web/tradeData?unitCode=" + localStorage.getItem("unitCode"))
        	.then((
        		res) => {
        	this.tradeData=res.data.data;
          this.transferData();
        	});
          

      },
    transferData() {
      this.unitCodes.push({name:localStorage.getItem("unitName"),"unitCode":localStorage.getItem("unitCode"),location:localStorage.getItem("location")});

     
      for (var i = 0; i < this.unitCodes.length; i++) {
        for(var j=0;j<this.tradeData.tradeAmtList.length;j++){
          if (this.unitCodes[i].name ==this.tradeData.tradeAmtList[j].unitName) {
            this.markers.push({
              position: [this.unitCodes[i].location.split(',')[0], this.unitCodes[i].location.split(',')[1]],
              name: this.unitCodes[i].name,
              amount:this.tradeData.tradeAmtList[j].amount/10000,
              visible: true,
              draggable: false
            });
            continue;
          }
      }
      }
      console.log(this.markers)

      if(this.markers.length>0)
      this.center=this.markers[0].position;
    },
    markerInit(e) {
      console.log("marker init: ", e);
    },
    clickMarker() {
      alert("点击了标号");
    },
  },
};
</script>

<style lang="scss" scoped>
.map-wrapper {
  width: 100%;
  height: 100vh;
  /*background: teal;*/
  background-image: url("https://hbimg.huabanimg.com/29431c1ae57e34250406e642983cc586fd1723e61f1ca3-ILytYd_fw658/format/webp");
}

#container {
  width: 100%;
  height: 100%;
}
</style>
